import api from './api';

export function sendDataEnqury(params) {
    return api.post('/data-enquiry', params);
}